//
// Module for the Employer Reporting Exceptions Index view
//
rs.module("content/fund/account/employerreportingexceptions/index",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, grid, selectionLimit, codeValues) {

            // conditionally disable checkboxes and grid row selection
            _configureGridSelection();

            // Unpack Js Selectors
            var filter = $.js(jsSelectors.filter);
            var batchSelect = filter.js(jsSelectors.batchSelect);
            var workingBatchSelect = filter.js(jsSelectors.workingBatchSelect);

            var form = $.js(jsSelectors.form);
            var reviewSelectedButton = form.js(jsSelectors.reviewSelectedButton);
            var actionSelect = form.js(jsSelectors.actionSelect);
            var submitButton = form.js(jsSelectors.submitButton);

            // Get select helper(s) for drop down properties
            var batchSelectHelper = selectHelper.getHelper(batchSelect);
            var workingBatchSelectHelper = selectHelper.getHelper(workingBatchSelect);
            var actionSelectHelper = selectHelper.getHelper(actionSelect);

            // Add listeners for javascript events

            // On Batch Select change, enable/disable the working batch select
            batchSelect.change(function () {
                var selectedBatch = batchSelect.val();
                workingBatchSelectHelper.setDisabled(selectedBatch != '');
            });

            // On Working Batch Select change, enable/disable the batch select
            workingBatchSelect.change(function () {
                var selectedBatch = workingBatchSelect.val();
                batchSelectHelper.setDisabled(selectedBatch != '');
            });

            // Handle the review selected button click event
            reviewSelectedButton.click(function (e) {

                // We need to disable the action selector to properly send the "Review" action.
                actionSelectHelper.setDisabled(true);
            });

            // Enforce ValueCountLimit on below grid actions.
            // i.e. Since we can't send more than records than what is defined by the supplied selection limit on the post action, disable posting above that number.
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged) {

                    // If greater than the supplied selection limit, disable actions and add event message.
                    if (grid.selectedValues.length >= selectionLimit) {
                        eventBanner.addErrorMessages("Up to " + $.format.number(selectionLimit, "#,##0") + " records may be selected at one time.");
                        reviewSelectedButton.setDisabled();
                        submitButton.setDisabled();
                        actionSelectHelper.setDisabled(true);
                    }
                    else {
                        eventBanner.removeErrorMessages();
                        reviewSelectedButton.setDisabled(false);
                        submitButton.setDisabled(false);
                        actionSelectHelper.setDisabled(false);
                    }
                }

                _executeSelectionChanged = true;
            });

            // conditionally disable checkboxes and grid row selection
            function _configureGridSelection() {

                // Loop through the grid's nodes (in our case, transmittal batches) and mark rejected batches as disabled/unselectable
                grid.agGridApi.forEachNode((node) => node.selectable = (node.data.CurrentStatus[0] != codeValues.rejected));
                grid.agGridApi.deselectAll();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);